import { z } from "zod";
export const refuseBookingSchema = z.object({
    reason: z.string().max(2000).optional(),
});
